import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BootSize = ({ bootSize }: SpecProps<"boot_size">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (bootSize == null || bootSize === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.car.boot_size",
    message: "Boot size",
    comment: "Field for 'boot size' in ad specification",
  });
  const value = i18n.t({
    id: "itemPageLayout.common.litre.postfix",
    message: "{litre} L",
    comment: "Litre postfix in ad specification",
    values: {
      litre: formatNumber(bootSize, locale),
    },
  });

  return <FieldValuePair field={field} value={value} />;
};
